<template>
  <div class="user-wrapper">
    <div class="content-box">
      <!-- <div class="self-menu m-l-20 m-t-12">
        <tk-image
          :width="24"
          :height="24"
          style="height: 24px;"
          @click.native="toggle"
          :src="require('../../assets/images/menu.png')"
        />
        <notice-other style="margin-top:6px"></notice-other>
      </div> -->
<!--      <notice-icon class="action"/>-->
      <a-dropdown>
        <span class="action ant-dropdown-link user-dropdown-menu">
          <a-avatar class="avatar" size="small" :src="avatar()"/>
          <span>{{ nickname() }}</span>
        </span>
        <a-menu slot="overlay" class="user-dropdown-menu-wrapper">
          <a-menu-item>
            <router-link to="/account/setting/base?type=base">
              <a-icon type="setting"/>
              <span>账户设置</span>
            </router-link>
          </a-menu-item>
          <a-menu-divider/>
          <a-menu-item>
            <a @click="handleLogout">
              <a-icon type="logout"/>
              <span>退出登录</span>
            </a>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
// import NoticeIcon from '@/components/NoticeIcon'
// import NoticeOther from '@/components/NoticeOther'

export default {
  name: 'UserMenu',
  components: {
    // NoticeIcon,
    // NoticeOther
  },
  methods: {
    ...mapGetters(['nickname', 'avatar']),
    async handleLogout () {
      await this.confirm('提示', '确定要退出登录吗？')
      this.$router.replace('/user/login')
      this.$store.commit('clearUser')
    }
  }
}
</script>
